import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconEnum } from "@evc/web-components";
import { AppIdentity } from '@evc/platform';
import { VERSION } from '../app.constants';
import { ThirdPartyNoticeComponent } from "../third-party-notice/third-party-notice.component";
import { LicenseAgreementDialogComponent } from "../license-agreement/license-agreement-dialog/license-agreement-dialog.component";
import { EVC_MODAL_REF, EvcModalService, type ModalRef } from "../_shared/services/modal/evc-modal.service";
import { isDevelopment } from '../_shared/environment-helper';
import { NetworkStatusService } from '../_services/network-status.service';

@Component({
    selector: 'app-app-about',
    templateUrl: './app-about.component.html',
    styleUrls: ['./app-about.component.scss'],
    standalone: false
})
export class AppAboutComponent {

  circleInfoIcon = IconEnum.CircleInfo;
  public privacyPolicyLink = '';
  public cookieNoticeLink = '';

  public appIdentity: AppIdentity = {
    logo: './assets/applications/visol.svg#visol',
    title: this.translate.instant('topMenuBar.appTitle'),
  };

  get isOnline() {
    return this.networkStatusService.isOnline;
  }

  get isDev() {
    return isDevelopment();
  }

  get version() {
    return VERSION;
  }

  constructor(
    @Inject(EVC_MODAL_REF) private modalRef: ModalRef<any>,
    private evcModalService : EvcModalService,
    private translate: TranslateService,
    private networkStatusService: NetworkStatusService
  ) {
    this.privacyPolicyLink = this.translate.instant('links.privacy_notice.href');
    this.cookieNoticeLink = this.translate.instant('links.cookies.href');
  }

  gotoLicenseAgreement() {
    this.modalRef.close();
    this.evcModalService.showModal(LicenseAgreementDialogComponent);
  }

  gotoThirdPartyNotice() {
    this.modalRef.close();
    this.evcModalService.showModal(ThirdPartyNoticeComponent);
  }

  close() {
    this.modalRef.close();
  }
}
